import { ApiProperty } from "@nestjs/swagger";

export class RackStatusRequest {
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    zoneId:number;
}
